import { Routes } from '@angular/router';

import CalcShellComponent from './shell.component';

const routes: Routes = [
    {
        path: '',
        component: CalcShellComponent,
        children: [
            { path: '', pathMatch: 'full', redirectTo: 'straight' },
            {
                path: 'straight',
                loadComponent: () => import('@stair-craft/calc/straight'),
                data: {
                    stairType: 'straight',
                    seoTitle: $localize`:@@seoCalcStraightTitle:Прямая лестница — конструктор GoldenCalc`,
                    seoDescription: $localize`:@@seoCalcStraightDesc:Спроектируйте прямую деревянную лестницу: ступени, угол и объём древесины с проверкой по СНиП, стоимость — по запросу.`,
                },
            },
            {
                path: 'l',
                loadComponent: () => import('@stair-craft/calc/straight'),
                data: {
                    stairType: 'l-shape',
                    seoTitle: $localize`:@@seoCalcLShapeTitle:Г-образная лестница — конструктор GoldenCalc`,
                    seoDescription: $localize`:@@seoCalcLShapeDesc:Спроектируйте Г-образную лестницу с поворотом на 90°: забежные ступени или площадка, материалы и нормы, стоимость — по запросу.`,
                },
            },
            {
                path: 'u',
                loadComponent: () => import('@stair-craft/calc/straight'),
                data: {
                    stairType: 'u-shape',
                    seoTitle: $localize`:@@seoCalcUShapeTitle:П-образная лестница — конструктор GoldenCalc`,
                    seoDescription: $localize`:@@seoCalcUShapeDesc:Спроектируйте П-образную лестницу с разворотом на 180°: два марша, площадка, объём древесины, проверка по СНиП.`,
                },
            },
            {
                path: 'spiral',
                loadComponent: () => import('@stair-craft/calc/straight'),
                data: {
                    stairType: 'spiral',
                    seoTitle: $localize`:@@seoCalcSpiralTitle:Винтовая лестница — конструктор GoldenCalc`,
                    seoDescription: $localize`:@@seoCalcSpiralDesc:Спроектируйте винтовую лестницу: диаметр, высота подъёма, ступени и объём древесины, расчёт стоимости — по запросу.`,
                },
            },
        ],
    },
];

export default routes;
